// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type LegContextProperties = {
  arrival_datetime?: string;
  initial_position_in_list?: number;
  arrival_position_id?: number;
  departure_position_id?: number;
  num_changes?: number;
  departure_datetime?: string;
  final_position_in_list?: number;
  labels?:
    | 'fastest'
    | 'smartest'
    | 'cheapest'
    | 'second_fastest'
    | 'second_smartest'
    | 'second_cheapest';
  index?: number;
  duration_minutes?: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/leg_context/jsonschema/2-0-0';
export const legContextName = 'leg_context';
export class LegContext extends BaseTrackingContext<LegContextProperties> {
  constructor(properties: LegContextProperties) {
    super(legContextName, schema, properties);
  }
}
